module.exports = __webpack_public_path__ + "static/Career-hero-deb86b5ea0dcaf2ec23d1896c4871bbc.jpg";